import type { TargetDefinition } from '@/types/webflash';

/**
 * STM32F103C8 — Cortex-M3, 64 KB flash, 20 KB SRAM, no hardware CRC
 */
export const STM32F1: TargetDefinition = {
  name: 'STM32F103C8',
  partNumber: 'STM32F103C8',
  idcodes: [0x1BA01477], // Cortex-M3 SWD IDCODE
  cpuType: 'CM3',
  flashBase: 0x08000000,
  flashSize: 64 * 1024,   // 64 KB
  ramBase: 0x20000000,
  ramSize: 20 * 1024,     // 20 KB
  hasHardwareCRC: false,
  sectors: (() => {
    // STM32F1 medium-density: uniform 1 KB pages
    const sectors = [];
    for (let i = 0; i < 64; i++) {
      sectors.push({ address: 0x08000000 + i * 1024, size: 1024 });
    }
    return sectors;
  })(),
};
